import React from "react";
import masterplan from "../../assets/images/Aura Master Plan-01.jpg";
import Floorplan from "../../assets/images/floor_plan.jpg";
const MasterPlan = () => {
  return (
    <div id="master-plan">
      <section className="bg-[#ffffff] py-5 xl:py-16 text-[#000] overflow-hidden">
        <div className="max-w-screen-2xl mx-auto px-6">
          <div className="text-center mb-4 xl:mb-7 mx-auto leading-snug px-6">
            <h2 className="font-crimson text-3xl xl:text-5xl text-[#5e3920] pb-5">
            2 BHK Flats Master Plan & Floor Plan
            </h2>
            <p className="text-[#000000d9] max-w-3xl mx-auto text-center text-[16px] pb-5 mb-5 xl:text-[18px] font-inter leading-relaxed">
            Explore the master plan and floor plan of Aura by Tranquillo to understand the overall project layout and the planning of its 2 BHK homes.
          </p>
          </div>
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-7">
            <div className=" border  rounded-2xl  shadow-sm hover:shadow-md transition-shadow duration-300">
              <img
                src={masterplan}
                alt="Master Plan"
                className="w-full  rounded-lg"
              />
            </div>
            <div className=" border  rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300">
              <img
                src={Floorplan}
                alt="Flood Plan"
                className="w-full  rounded-lg h-full "
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MasterPlan;
